<template>

    <Page>

        <Page class="text-xl">

            <h2 class="mb-4 font-semibold text-2xl">We have a proven formula</h2>
            <ul class="font-normal text-white/80 list-disc pl-5">
                <li class="pl-3 mb-3">We’ve analysed global automotive markets around the world, for untapped revenue opportunities.</li>
                <li class="pl-3 mb-3">We’ve done it before with <span class="font-semibold">DealerCell</span> — delivering measurable growth for hundreds of dealerships and our partners.</li>
                <li class="pl-3">Now, we’re applying that same proven formula to a <span class="font-semibold text-cyan-400 uppercase">new to industry</span>, high-value revenue stream in one of the toughest, most saturated markets in the world.</li>
            </ul>

        </Page>

    </Page>

</template>